import React from "react";
import { ShieldCheck } from "lucide-react";
import BrandMark from "../common/BrandMark";

/** Split-screen frame shared by the sign-in and create-account screens. */
const AuthShell = ({ title, subtitle, children, footer }) => (
  <div className="grid min-h-screen bg-background lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)]">
    <aside className="relative hidden overflow-hidden bg-gradient-to-br from-[hsl(217_75%_52%)] via-[hsl(222_72%_46%)] to-[hsl(240_60%_42%)] text-white lg:flex lg:flex-col lg:justify-between lg:p-12">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-white/10" />
      <div className="pointer-events-none absolute -bottom-32 -left-16 h-96 w-96 rounded-full bg-white/5" />
      <div className="relative flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-lg font-bold text-[hsl(222_72%_46%)]">
          S
        </div>
        <span className="text-lg font-semibold">Soocher</span>
      </div>
      <div className="relative max-w-md">
        <h2 className="text-4xl font-semibold leading-tight">
          Run Soocher from one place.
        </h2>
        <p className="mt-4 text-base text-white/80">
          Doctors, patients, consultations, payouts and coupons, all managed
          from the admin console.
        </p>
      </div>
      <p className="relative flex items-center gap-2 text-sm text-white/80">
        <ShieldCheck className="h-4 w-4" /> Restricted to authorised administrators
      </p>
    </aside>

    <main className="flex items-center justify-center px-4 py-10 sm:px-8">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-3 lg:hidden">
          <BrandMark size={36} />
          <span className="text-lg font-semibold">Soocher Admin</span>
        </div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
        <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>
        <div className="mt-8">{children}</div>
        {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
      </div>
    </main>
  </div>
);

export default AuthShell;
